var render = function render() {
    var _vm = this,
        _c = _vm._self._c,
        _setup = _vm._self._setupProxy;return _c('div', { staticClass: "pt-cascader-node", class: {
            'is-expend': _vm.expended,
            'no-select': !_vm.type,
            'is-checked': _vm.checked || _vm.value
        }, on: { "click": function click($event) {
                !_vm.type && _vm.$emit('expand', !_vm.expended);
            } } }, [_c('div', { staticClass: "pt-cascader-node_label", attrs: { "title": _vm.tooltip } }, [_vm.type === 'checkbox' ? _c('el-checkbox', { attrs: { "value": _vm.checked || _vm.value }, on: { "change": function change($event) {
                return _vm.$emit('change', $event);
            } } }, [_vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.label))];
    })], 2) : _vm.type === 'radio' ? _c('el-radio', { attrs: { "value": _vm.checked || _vm.value, "label": true }, on: { "input": function input($event) {
                return _vm.$emit('change', true);
            } } }, [_vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.label))];
    })], 2) : _vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.label))];
    })], 2), _vm._v(" "), _c('pt-icon', { staticClass: "icon", attrs: { "size": 12 } }, [_vm._t("icon", function () {
        return [!_vm.isLeaf ? _c('ic-arrow-right', { nativeOn: { "click": function click($event) {
                    return _vm.$emit('expand', !_vm.expended);
                } } }) : _vm._e()];
    })], 2)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };